import { cloudflareWorkerReverseProxy } from '@/core/lib/cloudflare-worker-reverse-proxy';
import { ILinkPreviewResponse } from '@link-in-bio/domain';

const getReferrer = async () => {
  const source = document.referrer;
  if (!source) return 'Direct';

  const linkPreview: ILinkPreviewResponse = await cloudflareWorkerReverseProxy.post(`/link-preview`, {
    url: source,
  });

  return linkPreview.provider_display ?? 'Direct';
};

export default getReferrer;
